import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Enquiry from "./components/Enquiry";
import Footer from "./components/Footer";

function App() {
  return (
    <BrowserRouter>
      {" "}
      <Navbar />{" "}
      <Routes>
       <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} /> 
        {/* <Route path="/core-team" element={<CoreTeam />} /> */}
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/enquiry" element={<Enquiry />} /> {/* Franchise */}
        {/* <Route path="/franchise" element={<Franchise />} /> <Route path="/jta" element={<JTA />} /> <Route path="/registration/student" element={<StudentRegistration />} /> <Route path="/registration/volunteer" element={<VolunteerRegistration />} /> <Route path="/registration/training" element={<TrainingRegistration />} /> */}{" "}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
export default App;
